import { PURGE } from "redux-persist";
import { RESET, FORCE_RELOAD } from "../actions";

export const resetReducers = () => ({
  type: RESET,
  payload: {}
});

export const resetStorage = () => ({
  type: PURGE,
  result: () => {
    // Result handler for purge action
  },
  payload: {}
});

export const forceReload = () => ({
  type: FORCE_RELOAD,
  payload: {}
});
